import Icon from '@klv/atoms/icon';

import * as s from './styles/flowToolbar.module.scss';
import type { IFlowToolbar } from './types';

export const FlowToolbar = ({ zoomIn, zoomOut, zoom, fitView }: IFlowToolbar) => (
  <div className={s.toolbar}>
    <button className={s.button} onClick={zoomIn}>
      <Icon iconName="PlusOutline" fillColor='currentColor'/>
    </button>
    <div className={s.zoomPercentage}>{`${Math.round(zoom * 100)}%`}</div>
    <button className={s.button} onClick={zoomOut}>
      <Icon iconName="DashOutline" fillColor='currentColor'/>
    </button>
    <div className={s.boundary} />
    <button className={s.button} onClick={fitView}>
      <Icon iconName="ArrowNorthOutline" fillColor='currentColor'/>
    </button>
  </div>
);
